import { render, staticRenderFns } from "./ReportFarmerPromotionSummaries.vue?vue&type=template&id=77125f34&"
import script from "./ReportFarmerPromotionSummaries.vue?vue&type=script&lang=js&"
export * from "./ReportFarmerPromotionSummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports